import { ModalProps, Modal } from "react-bootstrap";
import React, { MouseEvent, useMemo, useRef, useState } from 'react'
import styles from './DraggableModal.module.less'


export default function DraggableModal(props: DraggableModalProps){
  const modalRef = useRef<HTMLDivElement>(null)
  const [dragStarted, setDragStarted] = useState<boolean>(false)
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const modalWidth = useMemo(() => {
    return props.size ? widthBySize[props.size] : defaultSize
  }, [props.size])
  const [elemPosition, setElemPosition] = useState<ElementPosition>({
    x: 0,
    y: 0
  })
  const [offset, setOffset] = useState<ElementPosition>({
    x: 0,
    y: 0
  })

    const handleDragStart = (e: MouseEvent<HTMLDivElement>) => {
      const modalPosition = modalRef.current?.getBoundingClientRect();
      setElemPosition({
        x: modalPosition?.left || 0,
        y: modalPosition?.top || 0
      })
      setOffset({
        x: e.clientX - (modalPosition?.x || 0),
        y: e.clientY - (modalPosition?.y || 0)
      })
      setDragStarted(true)
      setIsDirty(true)
    }

    const handleDrag = (e: MouseEvent<HTMLDivElement>) => {
      if(dragStarted){
        setElemPosition({
          x: e.clientX - offset.x,
          y: e.clientY - offset.y
        })
      }
    }

    const handleDragEnd = (event: MouseEvent<HTMLDivElement>) => {
      setDragStarted(false)
    }

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()
  }

  const handleClickOutside = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if(props.onHide){
      props.onHide()
    }
    setTimeout(() => {
      setIsDirty(false)
    }, 500)
  }

  return <Modal
      {...props}
      dialogClassName={styles.dialog}
      contentClassName={styles.content}
      onClick={handleClickOutside}
      onMouseMove={handleDrag}
    >
      <div
        className={styles.modal}
        ref={modalRef}
        style={{
          margin: 'auto',
          width: modalWidth,
          position: isDirty ? 'absolute' : 'static',
          top: elemPosition.y,
          left: elemPosition.x,
        }}
        onClick={handleClick}
      >
        <Modal.Header
          onMouseDown={handleDragStart}
          onMouseUp={handleDragEnd}
          style={{padding: '24px', cursor: dragStarted ? 'grabbing' : 'grab',}}
          closeButton
        >
          {props.headerNode}
        </Modal.Header>
        {props.children}
      </div>
    </Modal>
}

interface DraggableModalProps extends ModalProps{
  headerNode?: React.ReactNode
}
interface ElementPosition{
  x: number,
  y: number
}

type modalBreakpoints = 'sm' | 'lg' | 'xl'
type modalSizes = {
  [key in modalBreakpoints]: number
}
const widthBySize: modalSizes = {
  sm: 300,
  lg: 800,
  xl: 1140
}
const defaultSize = 500;
